import React, { useState, useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import classnames from 'classnames';
import { Header } from 'utto-react-components';
import { Toolbar, MenuItem } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';
import { useReduxSelector } from 'hooks';
import history from 'services/history';
import { getName } from 'ducks/auth/selectors';
import { ReactComponent as Logo } from 'logo-white.svg';
import { ReactComponent as LogoIcon } from 'uttoLogo.svg';
import { useAccountMenuButtons } from './template/hooks';
import { isLpmRadioDetection } from 'whitelabel';
import Footer from './footer';
import useStyles from './styles';

const SlimTemplate = ({ title, children, showMenu = false }) => {
  const classes = useStyles();
  const accountButtons = useAccountMenuButtons();
  const name = useReduxSelector(getName);
  const theme = useTheme();
  const screen_xs = useMediaQuery(theme.breakpoints.only('xs'));
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const onLogoClick = useCallback(() => history.push('/'), []);

  const { hostname, search } = window.location;
  const urlParams = new URLSearchParams(search);

  const isLpmRadioDetectionDomain = isLpmRadioDetection();

  // Detect theme changes for favicon switching
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkTheme(mediaQuery.matches);

    const handleThemeChange = (e) => {
      setIsDarkTheme(e.matches);
    };

    mediaQuery.addEventListener('change', handleThemeChange);
    return () => mediaQuery.removeEventListener('change', handleThemeChange);
  }, []);

  // Browser tab configuration for different domains
  const BrowserTab = () => {
    const getBrandingConfig = () => {
      if (isLpmRadioDetectionDomain) {
        return {
          tabTitle: 'LPM',
          faviconLight: require('../whitelabel/RadioDetection/favicon-light.ico'),
          faviconDark: require('../whitelabel/RadioDetection/favicon-dark.ico'),
          favicon: require('../whitelabel/RadioDetection/favicon-light.ico')
        };
      }
      return {
        tabTitle: 'UTTO',
        favicon: null
      };
    };

    const config = getBrandingConfig();

    // Get appropriate favicon based on theme
    const getFavicon = () => {
      if (isDarkTheme && config.faviconDark) {
        return config.faviconDark;
      }
      return config.faviconLight || config.favicon;
    };

    return (
      <Helmet>
        <title>{config.tabTitle} | {title || 'Dashboard'}</title>
        {getFavicon() && (
          <link rel="icon" type="image/x-icon" href={getFavicon()} />
        )}
      </Helmet>
    );
  };

  return (
    <div className={classes.page}>
      <BrowserTab />

      {!isLpmRadioDetectionDomain && (
        <Header
          logo={
            screen_xs ? (
              <LogoIcon className={classes.logo} onClick={onLogoClick} />
            ) : (
              <Logo className={classes.logo} onClick={onLogoClick} />
            )
          }
          classes={{
            bar: classes.header
          }}
          name={showMenu ? name : null}
          menuItems={
            showMenu
              ? accountButtons.map((item, index) => (
                  <MenuItem key={index} onClick={item.onClick}>
                    {item.label}
                  </MenuItem>
                ))
              : null
          }
        />
      )}
      <main className={classnames(classes.content, 'fix-scroll-padding')}>
        {!isLpmRadioDetectionDomain && <Toolbar />}
        {children}
      </main>
      <Footer classname={classes.footer} isLoginPage={isLpmRadioDetectionDomain} />
    </div>
  );
};

export default SlimTemplate;
